import React from "react";

import { clsx } from "clsx";

const styles: any = {
  width: {
    full: `max-w-full`,
    xl: `max-w-xl mx-auto px-midi sm:px-maxi xl:px-tera`,
    lg: `mx-auto max-w-[1200px] px-midi sm:px-maxi lg:px-tera`,
    md: `mx-auto max-w-[1000px] px-midi sm:px-maxi xl:px-tera`,
    sm: `mx-auto max-w-[770px] px-midi sm:px-maxi`,
    xs: `mx-auto max-w-[600px] px-midi sm:px-maxi`,
    "2xl": `max-w-2xl mx-auto px-midi sm:px-maxi xl:px-tera`,
  },
  background: {
    none: null,
    primary: `bg-primary`,
    beige: `bg-tertiary`,
    green: `text-white bg-secondary`,
    light: `bg-neutral text-primary`,
    lighter: `bg-neutral-alt`,
    lightest: `bg-white`,
    transparent: `bg-transparent`,
  },
  ratio: {
    none: null,
    square: `aspect-square`,
    landscape: `aspect-landscape`,
    "3/4": `aspect-3-4`,
    "4/3": `aspect-4-3`,
    "4/5": `aspect-4-5`,
    "9/16": `aspect-9-16`,
    "11/12": `aspect-11-12`,
    "12/13": `aspect-12-13`,
    "16/9": `aspect-16-9`,
  },
};

export const BackgroundContainer = (props: any) => (
  <section
    {...props}
    className={clsx(
      props.className,
      "w-full",
      styles.background[props.background || "none"],
    )}
  />
);

export const StyledContainer = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "w-full",
      styles.width[props.width || "2xl"],
      styles.ratio[props.ratio || "none"],
      styles.background[props.background || "none"],
    )}
  />
);
